import { forwardRef, useCallback, useRef } from "react";
import SignatureComponent, { SignatureComponentRef } from "@CubeComponents/Mui_Form/SignatureComponent";

interface SignDrawProps {
  setCreatedSignature: (data: string) => void;
  initialImageUrl?: string;
}

const SignDraw = forwardRef<SignatureComponentRef, SignDrawProps>(({ setCreatedSignature, initialImageUrl }, ref) => {
  // The forwarded ref may be absent OR a callback ref, neither of which can be read back, so the
  // component always owns an object ref for `saveBtnClick` and fans the instance out to the caller.
  const localRef = useRef<SignatureComponentRef | null>(null);
  const attachRef = useCallback(
    (instance: SignatureComponentRef | null) => {
      localRef.current = instance;
      if (typeof ref === "function") ref(instance);
      else if (ref) ref.current = instance;
    },
    [ref],
  );

  const saveBtnClick = () => {
    // `change` only fires from a mounted SignatureComponent, so the handle is set by then.
    const signature = localRef.current;
    if (!signature) return;
    setCreatedSignature(signature.getSignature());
  };
  return (
    <SignatureComponent
      ref={attachRef}
      id="signature"
      className="h-[12.5rem] w-full rounded-sm border border-[var(--primary-blue)]"
      change={saveBtnClick}
      saveWithBackground={false}
      initialImageUrl={initialImageUrl}
    />
  );
});
SignDraw.displayName = "SignDraw";
export default SignDraw;
